export function isTrue(answer) {
    return [true, "true", "yes", "taip"].includes(
        typeof answer === "string" ? answer?.toLowerCase() : answer
    );
}

export function isFalse(answer) {
    return [false, "false", "no", "ne"].includes(
        typeof answer === "string" ? answer?.toLowerCase() : answer
    );
}
